export default "/images/vendor/flag-icons/flags/1x1/ky.svg?d819b33e11b565639faf254e68db49f1";